// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__16O8g","log":"ModalInventoryLogs_log__3TTVO","date":"ModalInventoryLogs_date__11ogn","userName":"ModalInventoryLogs_userName__qRerR"};